import {createReducer} from '@reduxjs/toolkit'
import {getEventsMembersPageInfo} from '../actions/events-members-page'
import {EventsMembersPageState} from '../types'

export const eventsMembersPage = createReducer<EventsMembersPageState>(null, builder => {
  builder.addCase(getEventsMembersPageInfo.fulfilled, (state, action) => action.payload)
})
